




























import Vue from 'vue'
import mixin from '../mixins/notifications-mixin'
import NotificationPopup, {
    NotificationPopupButton
} from '@/types/NotificationPopup.interface'
import Notification, { NotificationData } from '@/types/Notification.interface'
export default Vue.extend({
    mixins: [mixin],
    props: {
        idx: {
            type: Number,
            default: 0
        },
        notification: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            height: 48,
            timeout: null,
            visible: true
        }
    },
    mounted() {
        //  Only calculate the height if this is not the only element
        this.calcHeight()

        //  If this notification has static as a property, return
        if (this.notification.error) return

        //  Start a timeout for our notification to close automatically
        this.timeout = setTimeout(() => {
            this.visible = false
            this.$store.commit('notificationPopupClose', this.notification.id)
        }, 5000)
    },
    computed: {
        notificationPopup(): NotificationPopup[] {
            return this.$store.getters.notificationPopup
        },
        previousNotification(): Notification {
            //  If the length is 1 OR if this is the first index, then return null
            if (this.notificationPopup.length <= 1 || this.idx === 0) return null

            //  Else, grab the previous notification
            return this.notificationPopup[this.idx - 1]
        }
    },
    methods: {
        //  Convert a popup notification to a standard notification
        convertToNotification(popup): Notification {
            //  Assemble notification data
            const data: NotificationData = {
                category: popup.category,
                color: popup.color,
                icon: popup.icon,
                sender_id: popup.sender_id,
                text: popup.text,
                title: popup.title,
                route: popup.route,
                action: popup.action
            }

            //  Convert the popup notification schema, to standard Notification schema
            const notification: Notification = {
                id: popup.id,
                object: 'Notification',
                notifiable_id: popup.sender_id,
                notifiable_type: 'App\\Models\\Main\\User',
                data: data,
                category: popup.category,
                type: popup.type,
                read_at: null,
                created_at: null,
                updated_at: null,
                deleted_at: null
            }

            return notification
        },
        calcHeight(): void {
            //  If there is no previous notification, then we need to calculate our current notification height
            const elem = document.getElementById(`notif-${this.notification.id}`)

            // Grab the height of our element
            const clientHeight = elem.clientHeight

            //  If no previous element, set notification height to our client height
            if (!this.previousNotification) {
                this.height = 48
                this.notification.height = clientHeight
                return
            }

            //  Else, grab our previous height
            const prevHeight = this.previousNotification.height

            //  If index is 1 or less, additional is 48
            const additional = this.idx <= 1 ? 48 : 0

            //  Our total height is the previous height + 10 + any additional height we might need
            const height = prevHeight + 10 + additional

            /**
             * Notification height is equal to height occupied from the top, to the bottom of our element
             *
             * Height variable is equal to height occupied from the top to the top of our element
             */

            //  Set our notification height to that total height + our current height
            this.notification.height = height + clientHeight

            //  Set our height to just the total height
            this.height = height
        },
        closeNotification(): void {
            //  Clear our timeout
            clearTimeout(this.timeout)

            //  Remove our notification
            this.visible = false
            this.$store.commit('notificationPopupClose', this.notification.id)
        },
        handle(): void {
            //  If this is an error notification, refresh
            if (this.notification.reload) return location.reload()

            //  Convert the popup notification to standard notification
            const converted = this.convertToNotification(this.notification)

            //  Set the notification button/action
            const button = this.notificationButton(converted)

            //  If the notification has a handler, run it!
            if (button) button.callback()

            //  Close our notification
            this.closeNotification()
        },
        onButtonClicked(button: NotificationPopupButton): void {
            //  Close the notification
            this.closeNotification()

            //  Run the click method on the button
            window[button.click]()
        }
    },
    watch: {
        'notificationPopup.length'(val: number, prev: number): void {
            //  If our val ends up being smaller than the previous, we removed an element so recalculate heights
            if (val < prev) this.calcHeight()
        }
    }
})
